/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { SmartForm, CTAButtons } from 'components';
import { saveEmployee, getCurrentUser } from 'rdx/users';
import { saveAddress, getAddressesByOwnerID } from 'rdx/addresses';

import { schema, personalDetailsDefState } from './formShape';

import './personalDetails.scss';

function PersonalDetails() {
  const employeeRef = React.useRef(null);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const user = useSelector(getCurrentUser);
  const ownerAddresses = useSelector(getAddressesByOwnerID(user.id));
  const address = ownerAddresses[0];
  const [state, setState] = useState({
    ...personalDetailsDefState,
    ...user,
    ...address,
  });

  useEffect(() => {
    setState({ ...user, ...address });
  }, [address, user]);

  const submitEmployee = async (values) => {
    for (const key in user) {
      if (values[key] || values[key] === '') {
        user[key] = values[key];
      }
    }
    await dispatch(saveEmployee(user));
  };

  const submitAddress = async (values) => {
    for (const key in address) {
      if (values[key] || values[key] === '') {
        address[key] = values[key];
      }
    }
    if (user.employeeID) address.ownerID = user.employeeID;
    await dispatch(saveAddress(address));
  };

  const handleSubmit = async (values) => {
    setState({ ...values });
    await submitEmployee(values);
    await submitAddress(values);
    navigate('/setup/general');
  };

  const onNext = async () => {
    // if the form has been touched, try submitting first
    if (
      employeeRef.current &&
      employeeRef.current.touched &&
      Object.values(employeeRef.current.touched).length > 0
    ) {
      await employeeRef.current.submitForm();
    } else {
      // if it hasn't been touched, go to next page
      navigate('/setup/general');
    }
  };

  const buttons = {
    next: {
      onClick: onNext,
    },
  };

  return (
    <div className="d-flex flex-fill flex-column">
      <SmartForm
        grid
        ref={employeeRef}
        fields={schema}
        state={state}
        handleSubmit={handleSubmit}
      />
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default PersonalDetails;
